export enum DocumentNodeType {
  GENERAL = "GENERAL",
  PERSONAL = "PERSONAL",
}
